import { CircularProgress, Typography } from '@mui/material'
import { FC, memo } from 'react'
import { ButtonCustomProps, StyledButton } from './Button.styles'

interface ButtonProps extends ButtonCustomProps {
  isLoading?: boolean
  textColor?: string
  backgroundColor?: string
  borderColor?: string
  className?: string
}

const ButtonComp: FC<ButtonProps> = memo(
  ({
    variant = 'contained',
    disabled = false,
    size = 'medium',
    children,
    isLoading,
    textColor,
    backgroundColor,
    borderColor,
    type,
    onClick,
    fullWidth,
    startIcon,
    endIcon,
    className,
    sx,
    ...others
  }: ButtonProps) => {
    return (
      <StyledButton
        {...others}
        size={size}
        variant={variant}
        disabled={disabled || isLoading}
        textColor={textColor}
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        type={type}
        onClick={onClick}
        fullWidth={fullWidth}
        startIcon={startIcon}
        endIcon={endIcon}
        className={className}
        // style={style}
      >
        {isLoading ? (
          <CircularProgress size={14} />
        ) : typeof children === 'string' ? (
          <Typography>{children}</Typography>
        ) : (
          children
        )}
      </StyledButton>
    )
  },
)

export default ButtonComp
